import { render } from "./Point.vue?vue&type=template&id=950e0a50&ts=true&lang=pug"
import script from "./Point.vue?vue&type=script&lang=ts"
export * from "./Point.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/CarrefourOneAPP/website/game/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__